import React, { memo, useMemo } from 'react';

import { ThemeProvider } from '@material-ui/styles';

import makeTheme from '~/assets/styles/makePrimaryColorTheme';
import { ColumnProvider } from './contexts/Column';
import Table from './containers/Table';
import './styles/print.css';

function List(props) {
  const theme = useMemo(() => makeTheme(props.paperProps.iconColor), [props.paperProps.iconColor]);

  return (
    <ThemeProvider theme={theme}>
      <ColumnProvider columns={props.columns}>
        <Table {...props} />
      </ColumnProvider>
    </ThemeProvider>
  );
}

List.defaultProps = {
  ...Table.defaultProps,
};

List.propTypes = {
  ...Table.propTypes,
};

export default memo(List);
